import { LicenseInfo } from '@mui/x-date-pickers-pro';

import { config } from './config';

LicenseInfo.setLicenseKey(config.mui.licenseKey);
